<template>
    <div class="flex flex-col gap-6">
        <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <!-- HCKM Socials -->
            <p class="font-bold text-black text-lg">HCKM Socials</p>

            <!-- Tabs -->
            <ul class="flex flex-wrap gap-2 md:gap-4 items-center">
                <li
                    v-for="(tab, index) in socialsTabs"
                    :key="index"
                    class="transition duration-400 cursor-pointer font-bold inline-block p-2 text-xs sm:text-sm text-center border-b-2 rounded-t-xl"
                    :class="{
                        'active border-gray-300': activeTab === tab.name,
                        'hover:text-black hover:border-gray-300 text-dashboard-lightGray dark:hover:text-gray-300 duration-300': activeTab !== tab.name
                    }"
                    :style="{ borderColor: activeSocialsTab !== tab.name ? getBackgroundColor(currentProductGroup) : '' }"
                    @click="handleClick(tab)"
                >
                    {{ tab.label }}
                </li>
            </ul>
        </div>

        <!-- Post -->
        <div v-if="productIds" v-show="activeSocialsTab === socialTabNames.NEWS">
            <Post :product-ids="productIds" />
        </div>

        <!-- Youtube -->
        <div v-show="activeSocialsTab === socialTabNames.YOUTUBE">
            <YoutubeSearchPost :product-group-name="currentProductGroupName" />
        </div>
    </div>
</template>

<script setup>
import { defineProps, reactive, ref } from 'vue';
import { getBackgroundColor } from '../../helpers.js';
import Post from './Posts.vue';
import YoutubeSearchPost from './YoutubeSearchPost.vue';

const props = defineProps({
    currentProductGroup: Object,
    productIds: Array
});

const socialTabNames = {
    NEWS: 'News',
    YOUTUBE: 'Youtube'
};

const currentProductGroupName = ref(props.currentProductGroup?.name);
const activeSocialsTab = ref('News'); // Default active tab
const activeTab = ref('News'); // Default active tab
const socialsTabs = reactive([
    { name: socialTabNames.NEWS, label: 'News', action: () => (activeSocialsTab.value = 'News') },
    { name: socialTabNames.YOUTUBE, label: 'Youtube', action: () => (activeSocialsTab.value = 'Youtube') }
]);

const handleClick = (tab) => {
    tab.action();
    activeTab.value = tab.name;
};
</script>
